import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ModelPortfolio } from '@ddt-web/domain';
import { Memoize } from '@ddt-web/generic-utils';

import { PillsFilterType } from '../pills';

@Component({
	selector: 'mp-families-table',
	templateUrl: './model-families-table.component.html',
	styleUrls: ['./model-families-table.component.scss']
})
export class ModelFamiliesTableComponent implements OnInit {
	@Input() public families: Array<any> = [];
	@Input() public default: boolean = false;
	@Input() public mode: string = '';
	@Input() public showCheckboxes: boolean = false;
	@Input() public allowMultiple: boolean = true;
	@Input() public selectedModelPortfolios: ModelPortfolio[] = [];
	@Output() public closeEnclosingModal = new EventEmitter();
	@Input() public maxLimit: number = 100;
	@Input() private pillsFilterType: PillsFilterType;
	@Input() public arrowLeft = false;
	@Input() public useDasPortfolioId: boolean = false;
	@Output() public onModelSelected: EventEmitter<any> = new EventEmitter();

	public contentsMap: Map<number, boolean> = new Map<number, boolean>();

	constructor(public contentService: ContentService) { }

	public ngOnInit(): void {
		if (this.families) {
			for (let i = 0; i < this.families.length; i++) {
				this.contentsMap.set(i, false);
			}
		}
	}

	public getArrowClass(key: number): string {
		return !this.arrowLeft ? 'arrow down ' + this.getItemClass(key) : 'arrow arrow-left down ' + this.getItemClass(key);
	}

	public getItemClass(key: number): string {
		return this.contentsMap.get(key) ? 'active' : '';
	}

	public closeModal(): void {
		this.closeEnclosingModal.emit(true);
	}

	public onModelPortfolioSelected(): void {
		this.onModelSelected.emit();
	}

	private onToggleCollapsible(key: number): void {
		this.contentsMap.set(key, !this.contentsMap.get(key));
	}

	@Memoize()
	public getFamilyName(family: any): string {
		return PillsFilterType[this.pillsFilterType] === 'CUSTOM' && family.enableCmsRenaming && family?.modelExternalName ? family?.modelExternalName : family.familyName;
	}
}
